/**
 * TPL Collection Picks — recently-viewed hydration for the grid layout.
 * Reads handles from localStorage (populated by tpl-product-carousel.js)
 * and fills the grid client-side.
 */
(function () {
  'use strict';

  var RECENT_KEY = 'tpl:recently-viewed';
  var RECENT_MAX = 12;

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function moneyFromCents(cents) {
    var rupees = Math.round((cents || 0) / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  function imageWithWidth(src, width) {
    if (!src) return '';
    return src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + width + 'x$1$2');
  }

  function currentProductHandle() {
    var m = window.location.pathname.match(/^\/products\/([^?#\/]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function renderCard(p, idx, settings) {
    if (!p || !p.handle) return '';
    var raw = p.featured_image || (p.images && p.images[0]) || '';
    var src = imageWithWidth(raw, 800);
    var srcset = [
      imageWithWidth(raw, 400) + ' 400w',
      imageWithWidth(raw, 600) + ' 600w',
      imageWithWidth(raw, 800) + ' 800w'
    ].join(', ');
    var sizes = '(min-width: 990px) 25vw, (min-width: 550px) 33vw, 50vw';

    var badge = '';
    if (!p.available) {
      badge = '<span class="tpl-picks__badge tpl-picks__badge--sold-out">' + escapeHtml(settings.soldOut) + '</span>';
    } else if ((p.tags || []).indexOf('limited-edition') !== -1) {
      badge = '<span class="tpl-picks__badge tpl-picks__badge--limited">' + escapeHtml(settings.limited) + '</span>';
    }

    var imageBlock = src
      ? '<img class="tpl-picks__image" src="' + escapeHtml(src) + '" srcset="' + escapeHtml(srcset) + '" sizes="' + escapeHtml(sizes) + '" loading="lazy" alt="' + escapeHtml(p.title) + '">'
      : '';

    var delay = (idx + 1) * 100;

    return [
      '<div class="tpl-picks__item" data-tpl-animate="fade-up" style="transition-delay: ', delay, 'ms;">',
        '<a href="', escapeHtml(p.url), '" class="tpl-picks__card">',
          '<div class="tpl-picks__image-wrapper">',
            imageBlock,
            badge,
          '</div>',
          '<div class="tpl-picks__info">',
            '<h3 class="tpl-picks__product-title">', escapeHtml(p.title), '</h3>',
            '<span class="tpl-picks__price">', moneyFromCents(p.price), '</span>',
          '</div>',
        '</a>',
      '</div>'
    ].join('');
  }

  function hydrate(sectionEl) {
    var gridEl = sectionEl.querySelector('.tpl-picks__grid[data-recently-viewed]');
    if (!gridEl) return;

    var currentHandle = gridEl.dataset.currentHandle || currentProductHandle();
    var limit = parseInt(gridEl.dataset.limit, 10) || RECENT_MAX;

    var list;
    try {
      list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];

    list = list.filter(function (h) { return h && h !== currentHandle; }).slice(0, limit);

    if (!list.length) {
      sectionEl.remove();
      return;
    }

    var settings = {
      soldOut: sectionEl.dataset.labelSoldOut || 'Sold Out',
      limited: sectionEl.dataset.labelLimited || 'Limited Edition'
    };

    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products
        .filter(function (p) { return p && p.handle && (!p.tags || p.tags.indexOf('addon') === -1); })
        .map(function (p, i) { return renderCard(p, i, settings); })
        .join('');

      if (!html) {
        sectionEl.remove();
        return;
      }
      gridEl.innerHTML = html;
      sectionEl.removeAttribute('hidden');
    });
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl.dataset.picksInit) return;
    sectionEl.dataset.picksInit = '1';
    if (sectionEl.dataset.picksSource === 'recent') {
      hydrate(sectionEl);
    }
  }

  function boot() {
    document.querySelectorAll('.tpl-picks').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.tpl-picks');
    if (section) initSection(section);
  });
})();
